import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { BoundingBox } from '@/types';

export type ChunkDocRef = { id: string; docId: string; boundingBoxes: BoundingBox[] };

export function useGetChunksBatch(matterId: string | null | undefined, chunkIds: string[]) {
  const { getFetchConfig } = useGetFetchConfig();

  const { isLoading, isError, data } = useQuery<ChunkDocRef[], Error>(
    [QueryEntity.Chunk, { matterId, chunkIds }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/chunks/batch`,
        getFetchConfig({ method: FetchMethod.POST, data: { chunkIds } }),
      );
      if (!res.ok) throw new Error('Failed to fetch chunks');
      return res.json();
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!matterId && chunkIds.length > 0,
    },
  );

  return { isLoading, isError, data: data ?? [] };
}
